module.exports = __webpack_public_path__ + "img/yq-pic1.aec68229.png";